<template>
    <v-card
        :color="lostInternet ? '#FFEFEE' : forceOffline ? '#FFF8E4' : 'rgba(73, 200, 79, .1)'"
        elevation="0"
        class="mb-4 px-2"
        width="100%"
    >
        <v-card-title>
            <v-row>
                <v-col class="pa-0">
                    <span class="onlineStatusLabel">Status</span>
                </v-col>
                <v-col
                    class="pa-0"
                    align-self="end"
                >
                    <v-switch
                        class="mt-0"
                        dense
                        inset
                        :input-value="!forceOffline"
                        hide-details="true"
                        @change="toggleForceOffline"
                    >
                        <template v-slot:label>
                            <span class="onlineSwitch">
                                {{ forceOffline ? 'Offline' : 'Online' }}
                            </span>
                        </template>
                    </v-switch>
                </v-col>
            </v-row>
        </v-card-title>
        <v-divider />
        <v-card-text class="onlineText px-0 py-1">
            <span class="onlineSinceText">
                {{ lostInternet ? 'You have no internet' :
                    forceOffline ? `Offline since ${offlineSince}`
                    : `Online since ${onlineSince ? onlineSince : '...'}`
                }}
            </span>
            <br>
            <div
                v-for="system of allSystems"
                :key="system.serverName"
            >
                <span v-if="system.serverName === connectedSystem && !lostInternet">
                    <!-- large bullet -->
                    &#x25cf;
                </span>
                <span
                    v-else-if="!lostInternet"
                    style="display:inline-block; width:7px"
                >
                    <!-- empty space to keep labels aligned -->
                </span>
                Server {{ system.serverName }} - {{ system.serverDomain }}
            </div>
        </v-card-text>
    </v-card>
</template>
<script>
import moment from 'moment';
import serviceWorkerManager from '../services/serviceWorkerManager';
import { isTruthy } from '../utils/isTruthy';

export default {
    computed: {
        onlineSince() {
            let onlineSince;

            if (this.$store.getters.onlineSince) {
                const date = moment(this.$store.getters.onlineSince);
                onlineSince = date.format('MM/DD/YYYY hh:mm:ss A');
            }

            return onlineSince;
        },
        offlineSince() {
            let offlineSince;

            if (this.$store.getters.offlineSince) {
                const date = moment(this.$store.getters.offlineSince);
                offlineSince = date.format('MM/DD/YYYY hh:mm:ss A');
            }

            return offlineSince;
        },
        connectedSystem() {
            return this.$store.getters.systemVariables.find(sysVar => sysVar.name === 'SYSID').value;
        },
        allSystems() {
            // If we have sysvar::SYSFEATURE_GEMINI then use all sysvar::SYSID_x that have a non-blank value
            // otherwise only use sysvar::SYSID_x where x = sysvar::SYSID
            var sysvarSYSID = this.$store.getters.systemVariables.find( v => v.name === 'SYSID').value;
            var sysvarSYSFEATURE_GEMINI = this.$store.getters.systemVariables.find( v => v.name === 'SYSFEATURE_GEMINI').value;
            if(isTruthy(sysvarSYSFEATURE_GEMINI)) {
                const allSystems = this.$store.getters.systemVariables
                    .filter(sysVar => /^SYSID_.$/.test(sysVar.name) && sysVar.value.length)
                    .map(systemSysVar => {
                        return {
                            serverName: systemSysVar.name.slice(-1),
                            serverDomain: systemSysVar.value.toLowerCase().replace('webtms','LocatorLOGiX'),
                        };
                    });
                return allSystems;
            }
            const sysvarSYSID_self = this.$store.getters.systemVariables.find( v => v.name === `SYSID_${sysvarSYSID}`).value;
            return [{
                serverName: sysvarSYSID,
                serverDomain: sysvarSYSID_self.toLowerCase().replace('webtms','LocatorLOGiX')
            }];

        },
        forceOffline() {
            return this.$store.getters.forceOffline;
        },
        lostInternet() {
            return this.$store.getters.lostInternet;
        },
    },
    methods: {
        toggleForceOffline(setOnline) {
            if (!setOnline) {
                this.$emit('going-offline');
                serviceWorkerManager.forceOffline();
            } else {
                this.$emit('going-online');
                serviceWorkerManager.goOnline();
            }
        }
    },
};
</script>
<style scoped>
.onlineStatusLabel {
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.001em;
    text-align: left;
}
.onlineSwitch {
    font-family: Roboto;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
    letter-spacing: 0.001em;
    text-align: left;
}
.onlineSinceText {
    color: var(--ll-text-primary);
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.004em;
    text-align: left;
}
.onlineText {
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.004em;
    text-align: left;
}
</style>
